export default "__VITE_ASSET__CIGN782F__"